import instance from '../../utils/Axios'
import { getAssetSigningDetails } from '../UploadServices'

const transformC2paData = async (c2paVerifiedData) => {
  const activeManifest = c2paVerifiedData?.metadata?.active_manifest
  const manifests = c2paVerifiedData?.metadata?.manifests
  const assertions = manifests?.[activeManifest]?.assertions
  const assetTitle = manifests?.[activeManifest]?.title
  const c2paIdentity = assertions?.find(
    (assertion) => assertion.label === 'c2pa.identity',
  )
  const c2paActions = assertions?.find(
    (assertion) => assertion.label === 'c2pa.actions',
  )
  const c2paActionCreated = c2paActions?.actions?.find(
    (action) => action?.parameters?.description,
  )

  let transformedC2paData = {
    appUsed: manifests?.[activeManifest]?.signature_info?.issuer,
    signedTime: manifests?.[activeManifest]?.signature_info?.time,
    verifyUrl: c2paIdentity?.data?.signer_payload?.signer?.uri,
    assetTitle,
    assetSummary: c2paActionCreated?.parameters?.description,
  }

  const verifyUrl = c2paIdentity?.data?.signer_payload?.signer?.uri

  if (verifyUrl) {
    if (verifyUrl.includes('assetId=')) {
      const slitUrl = verifyUrl.split('assetId=')
      const assetId = slitUrl[slitUrl.length - 1]

      const localSignedData = await getAssetSigningDetails(assetId)
      transformedC2paData = {
        ...transformedC2paData,
        ...localSignedData.signing,
      }
    }
  }

  return transformedC2paData
}

export const c2paRead = async (s3Url, identifier) => {
  try {
    const c2paVerify = await instance.post('/assets/c2pa-verify', {
      identifier,
      s3Url,
    })
    return {
      ...(await transformC2paData(c2paVerify?.data?.message)),
      url: s3Url,
    }
  } catch (err) {
    return null
  }
}
